/* eslint-disable max-len */
import 'react';

const SysDocTemplateMeetingSvg = (
    props: React.SVGProps<SVGSVGElement>
): React.PropsWithoutRef<React.ReactSVGElement> => (
    <svg
        width="130px"
        height="173px"
        viewBox="0 0 130 173"
        {...props}
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-64.000000, -309.000000)">
                <g transform="translate(64.000000, 309.000000)">
                    <g>
                        <path
                            d="M5.1277704,0.5 L124.87223,0.5 C126.513668,0.5 127.115921,0.653234454 127.717892,0.975172007 C128.281321,1.27649702 128.723503,1.71867923 129.024828,2.28210802 C129.346766,2.88407891 129.5,3.48633153 129.5,5.1277704 L129.5,5.1277704 L129.5,167.87223 C129.5,169.513668 129.346766,170.115921 129.024828,170.717892 C128.723503,171.281321 128.281321,171.723503 127.717892,172.024828 C127.115921,172.346766 126.513668,172.5 124.87223,172.5 L124.87223,172.5 L5.1277704,172.5 C3.48633153,172.5 2.88407891,172.346766 2.28210802,172.024828 C1.71867923,171.723503 1.27649702,171.281321 0.975172007,170.717892 C0.653234454,170.115921 0.5,169.513668 0.5,167.87223 L0.5,167.87223 L0.5,5.1277704 C0.5,3.48633153 0.653234454,2.88407891 0.975172007,2.28210802 C1.27649702,1.71867923 1.71867923,1.27649702 2.28210802,0.975172007 C2.88407891,0.653234454 3.48633153,0.5 5.1277704,0.5 L5.1277704,0.5 Z"
                            stroke="#E6E7EB"
                            fill="#FFFFFF"
                        />
                        <path
                            d="M4,0 L126,0 C128.209139,-4.05812251e-16 130,1.790861 130,4 L130,4 L130,4 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z"
                            fill="#4581FC"
                        />
                        <path
                            d="M4,0 L126,0 C128.209139,-4.05812251e-16 130,1.790861 130,4 L130,4 L130,4 L0,4 C-2.705415e-16,1.790861 1.790861,4.05812251e-16 4,0 Z"
                            fill="#4581FC"
                        />
                        <text
                            fontFamily="PingFangSC-Regular, PingFang SC"
                            fontSize="12"
                            fontWeight="normal"
                            fill="#77787A"
                        >
                            <tspan x="16" y="111">
                                {'\u8BAE\u7A0B'}
                            </tspan>
                        </text>
                        <circle fill="#D6E3FC" cx="20" cy="123" r="4"></circle>
                        <rect fill="#D6E3FC" x="28" y="119" width="86" height="8" rx="1"></rect>
                        <g transform="translate(16.000000, 50.000000)" fill="#EEEFF1">
                            <rect x="0" y="0" width="98" height="8" rx="1"></rect>
                            <rect x="0" y="14" width="98" height="8" rx="1"></rect>
                            <rect x="0" y="28" width="46" height="8" rx="1"></rect>
                        </g>
                        <g transform="translate(16.000000, 16.000000)"></g>
                    </g>
                    <g transform="translate(16.000000, 133.000000)" fill="#D6E3FC">
                        <circle cx="4" cy="4" r="4"></circle>
                    </g>
                    <g transform="translate(16.000000, 147.000000)" fill="#D6E3FC">
                        <circle cx="4" cy="4" r="4"></circle>
                    </g>
                    <g transform="translate(28.000000, 133.000000)" fill="#D6E3FC">
                        <rect x="0" y="0" width="86" height="8" rx="1"></rect>
                    </g>
                    <g transform="translate(28.000000, 147.000000)" fill="#D6E3FC">
                        <rect x="0" y="0" width="86" height="8" rx="1"></rect>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);
export default SysDocTemplateMeetingSvg;
